import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import { DatePicker, Drawer, message, Popconfirm, Select } from "antd";
import { map } from "lodash";
import moment from "moment-timezone";
import React, { Component } from "react";
import * as yup from "yup";
import Loader from "../../../../Common/Component/Loader";
import {errorHandle} from "../../../../Common/errorHandle";

const { Option } = Select;

class PauseService extends Component {
  state = {
    pauseReason: {},
    uuid: "", 
    pause_from: "",
    pause_to: "",
    reason: "",
    suspend_until_manual: false,
    is_btn_active: false,
    loader: false,
    errors: {},
    is_update: false,
    is_current_pause: false
  };

  componentDidMount = () => {
    this.setState({ loader: true });
    this.props.getPauseReason(); // get pause reason
    this.props.getPauseService({ service_order__uuid: this.props.serviceId }); // get pause service list
    if (this.props?.selectedService?.pause_obj && Object.keys(this.props?.selectedService?.pause_obj).length > 0) {
      let is_current_pause = this.isToday(this.props?.selectedService?.pause_obj?.pause_from)
      let suspend_until_manual = this.props?.selectedService?.pause_obj?.pause_to === null ? true : false;
      this.setState({
        uuid: this.props?.selectedService?.pause_obj?.uuid ? this.props?.selectedService?.pause_obj?.uuid : "",
        pause_from: this.props?.selectedService?.pause_obj?.pause_from ? moment(this.props?.selectedService?.pause_obj?.pause_from) : '',
        pause_to: this.props?.selectedService?.pause_obj?.pause_to ? moment(this.props?.selectedService?.pause_obj?.pause_to) : "",
        reason: this.props?.selectedService?.pause_obj?.reason?.uuid ? this.props?.selectedService?.pause_obj?.reason?.uuid : "",
        is_update: true,
        is_current_pause: is_current_pause,
        suspend_until_manual: suspend_until_manual
      }, () => {
        //TODO:
      }) 
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setState({ loader: false });
    // message.destroy();

    // if (Object.keys(nextProps?.service?.errors).length > 0 && nextProps?.service?.errors !== this.props?.service?.errors) {
    //   this.setState({loader: false});
    //   errorHandle(nextProps?.service?.errors)
    // }

    if (Object.keys(nextProps?.service?.pauseService).length > 0 && nextProps?.service?.pauseService !== this.props?.service?.pauseService) {
      this.setState({loader: false});
      this.props.getServiceOrder({ user__uuid: nextProps.customerId }) // get service orders
      message.success('Service Paused Successfully.', 10);
    }

    if (Object.keys(nextProps?.service?.pauseReason).length > 0) {
      this.setState({ pauseReason: nextProps?.service?.pauseReason });
    }
  };

  isToday(momentDate) {
    var REFERENCE = moment(new Date()).format("YYYY-MM-DD");
    if (REFERENCE === momentDate) {
      return true;
    } else {
      return false;
    }
  }

  // on Text change
  onTextChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // validate required fields
  validate = () => {
    const { pause_from, pause_to, reason, suspend_until_manual, is_update } = this.state;
    const schema = yup.object().shape({
      suspend_until_manual: yup.bool(),
      pause_from: yup.string().required("Select a Pause Start Date."),
      pause_to: yup.string().when("suspend_until_manual", {
        is: (suspend_until_manual) => !suspend_until_manual,
        then: yup.string().required("Select a Pause End Date."),
      }),
      to_err: (pause_from && pause_to && pause_to <= pause_from) ? yup.string().required("End Date must be later than Start Date."): null,
      reason: yup.string().required("Reason is required"),
    });

    const data = { suspend_until_manual, pause_from, pause_to, reason };
    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({ is_btn_active: true, errors: {} });
        if (is_update) {
          /**
           * AUTHOR: Ritesh Solanki
           * <DP-3088>Edit a Service Pause for a Residential Customer</DP-3088>
           */
          this.onPauseUpdate();
        } else {
          this.onPause();
        }        
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {
          err_data[item.path] = item.message;
        });
        this.setState({ errors: err_data, is_btn_active: false });
      });
    }, 200);
  };

  // on pause
  onPause = () => {
    const { serviceId } = this.props;
    const { pause_from, pause_to, reason, suspend_until_manual } = this.state;
    Promise.allSettled([
      this.props.pauseService({
        service_order_uuid: serviceId,
        understand_pause_func: false,
        pause_from: moment(pause_from).format("YYYY-MM-DD"),
        pause_to: pause_to ? moment(pause_to).format("YYYY-MM-DD") : null,
        service_reason_uuid: reason,
        suspend_until_manual,
      })
    ]).then(result => {
      const { service } = this.props;
      if (service && Object.keys(service?.pauseService).length > 0) {
        this.onCancel();
      }
    });
  };

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3088>Edit a Service Pause for a Residential Customer</DP-3088>
   */
  onPauseUpdate = () => {
    const { serviceId } = this.props;
    const { pause_from, pause_to, reason, suspend_until_manual, uuid } = this.state;
    this.setState({ loader: true });
    this.props.updatePauseService(uuid, {
      service_order_uuid: serviceId,
      understand_pause_func: false,
      pause_from: moment(pause_from).format("YYYY-MM-DD"),
      pause_to: pause_to ? moment(pause_to).format("YYYY-MM-DD") : null,
      service_reason_uuid: reason,
      suspend_until_manual,
      is_end_pause: false
    });
    setTimeout(() => {
      this.onCancel();
    }, 1500)
  };

  // on cancel
  onCancel = () => {
    const { closeDrawer } = this.props;
    closeDrawer && closeDrawer();
    this.onClear();
  };

  // on clear
  onClear = () => {
    this.setState({ pause_from: "", pause_to: "", reason: "", suspend_until_manual: false, errors: {} });
  };

  render() {
    const { closeDrawer, visible } = this.props;
    const { pause_from, pause_to, reason, suspend_until_manual, loader, pauseReason, errors, is_update, is_current_pause } = this.state;
    return (
      <Drawer
        placement={"right"}
        closable={false}
        onClose={closeDrawer}
        visible={visible}
        key={"right"}
        width={"400"}
        className="drawer-wrapper"
      >
        <div className="filter_drawer_wrapper  rdrawer">
          {loader && <Loader/>}
          <div className="card-head flex ai-center">
            <h4>{is_update ? 'Edit' : 'Add'} Pause</h4>
            <CloseOutlined onClick={closeDrawer}/>
          </div>
          <div className="card-row flex-column">
            <div className="card-full">
              <div className="form-group">
                <div className="fitem">
                  <div className="fitem">
                    <label>Pause Start Date<sup>*</sup></label>
                    <DatePicker
                      disabledDate={(current) => {
                        return moment().add(-1, 'days') >= current
                      }}
                      disabled={is_current_pause}
                      placeholder={"mm-dd-yyyy"}
                      format={"MM-DD-YYYY"}
                      value={pause_from ? moment(pause_from) : null}
                      onChange={(e) => {
                        if (e) {
                          this.setState({pause_from: e });
                        } else {
                          this.setState({ pause_from: '' });
                        }                        
                      }}
                      className="reverse"/>
                    {errors?.["pause_from"] ?
                      <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.["pause_from"]}</label> : ""}
                  </div>
                  <button className="success btn plain-btn" onClick={() => { this.setState({'pause_from':  moment(new Date()).format("YYYY-MM-DD")}) }}>
                    <b>Today</b>
                  </button>
                  <button className="success btn plain-btn" onClick={() => { this.setState({'pause_from':  moment().add(1, "days").format("YYYY-MM-DD")}) }}>
                    <b>Tomorrow</b>
                  </button>
                </div>
                <div className="fitem">
                  <div className="fitem">
                    <label>Pause End Date<sup>*</sup></label>
                    <DatePicker
                      inputReadOnly
                      disabled={suspend_until_manual}
                      disabledDate={(endValue) => {
                        return endValue.valueOf() < moment(moment(pause_from, "DD/MM/YYYY").add(1, 'days')).valueOf();
                      }}
                      placeholder={"mm-dd-yyyy"}
                      format={"MM-DD-YYYY"}
                      value={pause_to ? pause_to : null}
                      onChange={(e) => { 
                        if (e) {
                          this.setState({pause_to: e });
                        } else {
                          this.setState({ pause_to: '' });
                        }                        
                      }}
                      className="reverse"/>
                    {errors?.["pause_to"] ?
                      <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.["pause_to"]}</label> : ""}
                  </div>
                </div>
              </div>
              <div className="fitem-check mt-10">
                <input
                  type="checkbox"
                  className="fitem-ck-input"
                  id="pauseUntil"
                  name="pauseUntil"
                  checked={suspend_until_manual}
                  onChange={(e) => this.setState({ suspend_until_manual: !suspend_until_manual, pause_to: "" })}
                />
                <label htmlFor="pauseUntil" className="fitem-ck-txt">Pause until manuallly resumed</label>
              </div>
              <div className="fitem half-fitem mt-10">
                <label>Reason for Pause<sup>*</sup></label>
                <div>
                  <Select
                    showArrow
                    showSearch
                    placeholder={"Select a reason for pausing this service"}
                    virtual={false}
                    style={{ width: "100%" }}
                    value={reason || undefined}
                    onChange={(e) => this.onTextChange({ target: { name: "reason", value: e } })}
                  >
                    {map(pauseReason?.results, (x) => <Option value={x.uuid} key={x.uuid}>{x.reason}</Option>)}
                  </Select>
                  {errors?.["reason"] ?
                    <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.["reason"]}</label> : ""}
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <button className={`btn btn-bdr`} onClick={() => this.onCancel()}>Cancel</button>
            <button className={`btn btn-warning`} onClick={() => this.validate()}> {is_update ? 'Update' : 'Add'} Pause</button>
          </div>
        </div>
      </Drawer>
    );
  }
}
export default PauseService;
